import { pdf } from '@react-pdf/renderer';

const downloadPDF = async (docElement, filename) => {
  const blob = await pdf(docElement).toBlob();
  const url = URL.createObjectURL(blob);
  const link = window.document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};

export default downloadPDF;
